import { render, staticRenderFns } from "./StudentExamResults.vue?vue&type=template&id=41878520"
import script from "./StudentExamResults.vue?vue&type=script&lang=js"
export * from "./StudentExamResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports